import type { Locale } from 'date-fns'
import { de, enUS, es, fr, it, ptBR } from 'date-fns/locale'

import type { Locale as AppLocale } from '@/stores/language'

/** The date-fns locale behind each app locale, for calendars and date formatting. */
export const DATE_FNS_LOCALES: Record<AppLocale, Locale> = {
  enUs: enUS,
  ptBr: ptBR,
  esEs: es,
  frFr: fr,
  deDe: de,
  itIt: it,
}
